import Vue from "vue";
import Vuex from "vuex";
import Axios from "axios";
import { router } from "../main";

import clients from "./clients";
import confirm_dialog from "./confirm_dialog"

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    token: null,
    message: "",
    loading: false,
    snackbar: {},
    packageVersion: process.env.PACKAGE_VERSION || '0'
  },
  getters: {
    isLoggedin: state => {
      return state.user ? true : false;
    },
    getAppVersion: state => {
      return state.packageVersion
    },
    getUser: state => {
      return state.user;
    },
    getToken: state => {
      return state.token;
    },
    getMessage: state => {
      return state.message;
    },
    isAdmin: state => {
      if (state.user) {
        return state.user.admin;
      } else return false;
    },
    getLoading: state => {
      return state.loading;
    },
    getSnackbar: state => state.snackbar
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
      const token_data = token.split(".");
      const data = atob(token_data[1]);
      const user = JSON.parse(data);
      state.user = user;
      Vue.prototype.$http.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${state.token}`;
      localStorage.setItem("token", state.token);
    },
    removeToken(state) {
      localStorage.removeItem("token");
      state.user = null;
      state.token = null;
      Vue.prototype.$http.defaults.headers.common["Authorization"] = ``;
    },
    setMessage(state, message) {
      state.message = message;
    },
    setLoading(state, payload) {
      state.loading = payload.loading;
    },
    sendMessage(state, payload) {
      state.snackbar = { ...payload, active: true };
    },
    error(state, text) {
      state.snackbar = { text, color: "red", active: true };
    },
    success(state, text) {
      state.snackbar = { text, color: "success", active: true };
    },
    warning(state, text) {
      state.snackbar = { text, color: "orange", active: true };
    },
    closeMessage(state) {
      state.snackbar.active = false;
    }
  },
  actions: {
    login(context, token) {
      return new Promise((resolve, reject) => {
        context.commit("setToken", token);
        resolve();
      });
    },
    logout(context) {
      context.commit("removeToken");
    },
    checkToken(context) {
      return new Promise((resolve, reject) => {
        let token = context.getters.getToken;
        if (!token) {
          if (localStorage.getItem("token")) {
            token = localStorage.getItem("token");

            Vue.prototype.$http.post("/auth/verify", { token }).then(r => {
              if (r.data.valid) {
                context.commit("setToken", token);
              } else {
                context.commit("setMessage", r.data.message);
                context.dispatch("logout");
              }

              return resolve();
            });
          } else {
            context.commit("setMessage", "Faça login para acessar o conteúdo");
            context.dispatch("logout");
            return resolve();
          }
        } else if (!localStorage.getItem("token")) {
          context.commit("setMessage", "Você fez logout em outra aba");
          context.dispatch("logout");
          return resolve();
        } else {
          return resolve();
        }
      });
    }
  },
  modules: {
    clients: clients,
    confirm_dialog: confirm_dialog
  }
});
